<span [class]="modifierClass">{{ label }}</span>
